import styled from "styled-components";
import { TopicElement } from "shared/types";

interface Props {
  data: TopicElement;
}

export default function MediumHeader({ data }: Props) {
  return (
    <>
      <H3>{data.title}</H3>
      <Border />
    </>
  );
}

const H3 = styled.h3`
  font-weight: 600;
  font-size: 16px;
  letter-spacing: 0.47px;
  line-height: 28px;
  color: #3c424a;
`;

const Border = styled.div`
  width: 100%;
  height: 1px;
  background: linear-gradient(#e68ab4, #a84fb2);
  margin-top: 4px;
`;
